import { isEmpty } from 'lodash';
import { connect } from 'react-redux';

import SecondaryNavigation from 'components/CollectionSecondaryNavigation';
import { BREADCRUMB_NAVIGATION_LINK_TYPES } from 'constants/breadcrumbNavigation';
import * as actions from 'state/actions';
import CollectionPage from 'state/selectors/collection-page';
import BreadcrumbsUtil from 'utils/Breadcrumbs';

const mapStateToProps = (state, ownProps) => {
  const type = BREADCRUMB_NAVIGATION_LINK_TYPES.COLLECTION;
  const handle = CollectionPage.getCollectionHandle(state);

  const { secondaryNavigationOptions } = BreadcrumbsUtil.getSecondaryNavigationOptions({
    type,
    handle,
  });

  return {
    secondaryNavigationOptions,
    ...ownProps,
  };
};

const mapDispatchToProps = dispatch => ({
  trackNavigation: (url, experimentEngagementIds) => {
    if (!isEmpty(experimentEngagementIds)) {
      dispatch(
        actions.trackEngagementClick({
          eventCategory: 'Collections',
          eventAction: 'Secondary Navigation',
          eventLabel: url,
          ...experimentEngagementIds,
        })
      );
    }
    dispatch(actions.trackSecondaryNavigationNavigation(url));
    // Because this function will be added to an <a> tag's onClick handler, it needs to return true to not prevent navigation
    return true;
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(SecondaryNavigation);
